import React from "react";

import workPassportConnectedComplianceLoopAccreditedTrainingDesktop from "../../images/work-passport-connected-compliance-loop-accredited-training-desktop.webp";
import workPassportConnectedComplianceLoopAccreditedTrainingMobile from "../../images/work-passport-connected-compliance-loop-accredited-training-mobile.webp";
import workPassportConnectedComplianceLoopFiveStageProcessDesktop from "../../images/work-passport-connected-compliance-loop-five-stage-process-desktop.svg";
import workPassportConnectedComplianceLoopFiveStageProcessMobile from "../../images/work-passport-connected-compliance-loop-five-stage-process-mobile.svg";

import "./WorkPassportConnectedComplianceLoop.css";

export default function WorkPassportConnectedComplianceLoop() {
  return (
    <section
      className="work-passport-connected-compliance-loop"
      id="work-passport-connected-compliance-loop"
      aria-labelledby="work-passport-connected-compliance-loop-title"
    >
      <div className="work-passport-connected-compliance-loop__shell">
        <div className="work-passport-connected-compliance-loop__top">
          <figure className="work-passport-connected-compliance-loop__photo">
            <picture>
              <source
                media="(max-width: 620px)"
                srcSet={workPassportConnectedComplianceLoopAccreditedTrainingMobile}
              />
              <img
                src={workPassportConnectedComplianceLoopAccreditedTrainingDesktop}
                alt="Industrial workers participating in practical accredited first-aid training"
                loading="lazy"
              />
            </picture>
            <figcaption>
              <span aria-hidden="true" />
              Accredited delivery · practical evidence
            </figcaption>
          </figure>

          <div className="work-passport-connected-compliance-loop__copy">
            <p className="work-passport-connected-compliance-loop__kicker">
              From warning to completed training
            </p>
            <h2 id="work-passport-connected-compliance-loop-title">
              One connected <em>compliance loop.</em>
            </h2>
            <p>
              Work Passport connects forecast risk to accredited delivery through
              AndUs and the TPC group—then refreshes the completed evidence
              automatically.
            </p>
            <aside className="work-passport-connected-compliance-loop__governance">
              <span aria-hidden="true">✓</span>
              <div>
                <small>The operational difference</small>
                <strong>
                  Managers govern the rules and exceptions. The system handles
                  recurring coordination.
                </strong>
              </div>
            </aside>
          </div>
        </div>

        <picture className="work-passport-connected-compliance-loop__process">
          <source
            media="(max-width: 620px)"
            srcSet={workPassportConnectedComplianceLoopFiveStageProcessMobile}
          />
          <img
            src={workPassportConnectedComplianceLoopFiveStageProcessDesktop}
            alt="Detect, group, schedule, train and update compliance loop"
            loading="lazy"
          />
        </picture>
      </div>
    </section>
  );
}
